<app-breadcrumb-item [level]="0" (onClick)="homeClicked.emit()">
  <mat-icon breadcrumb-item-prefix  class="home"> home </mat-icon>
</app-breadcrumb-item>

@for (breadcrumb of breadcrumbs(); track breadcrumb.type + ':' + breadcrumb.label + ':' + breadcrumb.popCount; let i = $index) {
  <app-breadcrumb-item
    [level]="i + 1"
    [item]="breadcrumb"
    (onClick)="breadcrumbClicked.emit($event)">
    {{ breadcrumb.label }}
  </app-breadcrumb-item>
}

@if (forms()?.length) {
  <app-breadcrumb-item [level]="breadcrumbs().length + 1">
    <app-form-selector breadcrumb-item-prefix [forms]="forms()" (formSelected)="formSelected.emit($event)" />
  </app-breadcrumb-item>
}
